// React
import React, { Component } from 'react';
import {ButtonGroup, Tooltip} from '@material-ui/core/';
import {functions} from 'constants/index';
import {FindInPage, CheckCircleOutline, Block} from '@material-ui/icons/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux

import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Footer from 'pages/Home/Footer2';
import Title from 'components/TitleWithIcon';
import ComponenteDeFiltrosParaBusqueda from './Filtros/index'
import Modal from 'components/CustomDialog';

const  ConsultaPorFolio= (props)=> {
        return (
            <Modal 
                open={props.open}
                fullScreen={true}
                closeModal={props.closeModal}
                actualizarTabla={props.actualizarTabla}
                iconToolbar={<FindInPage />}
                titleToolbar={'Consulta de Datos'}
            >
                <Title title={'Búsqueda por número de folio'} icon={"/menu/Document.png"}/>
                <ComponenteDeFiltrosParaBusqueda open={props.open}/>
                <br/><br/><br/><Footer />
            </Modal>
        )
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultaPorFolio);